import { R32_MATCHES, R16_MATCHES, QF_MATCHES, SF_MATCHES } from '../data/tournament';

// Map each match ID to the next match it feeds into
const NEXT_MATCH = {};
for (const m of [...R32_MATCHES, ...R16_MATCHES, ...QF_MATCHES, ...SF_MATCHES]) {
  if (m.nextMatch) NEXT_MATCH[m.id] = m.nextMatch;
}

// Matches at QF level and above feed into the SF losers → 3rd place match
const QF_OR_ABOVE = new Set(['qf_m01','qf_m02','qf_m03','qf_m04','sf_m01','sf_m02','final']);

/**
 * Returns an updated knockout object after picking `teamId` for `matchId`.
 * Clears any downstream picks that are now invalid (the old winner no longer
 * advances), and clears the 3rd-place pick if SF participants may have changed.
 */
export function advanceKnockoutPick(knockout, matchId, teamId) {
  const oldWinnerId = knockout[matchId];
  const updated = { ...knockout, [matchId]: teamId };

  let qfTouched = QF_OR_ABOVE.has(matchId);

  if (oldWinnerId && oldWinnerId !== teamId) {
    let cur = matchId;
    while (true) {
      const nextId = NEXT_MATCH[cur];
      if (!nextId) break;
      if (updated[nextId] === oldWinnerId) {
        if (QF_OR_ABOVE.has(nextId)) qfTouched = true;
        delete updated[nextId];
        cur = nextId;
      } else {
        break;
      }
    }
  }

  // 3rd-place teams are SF losers — any QF-level or higher change invalidates them
  if (qfTouched) delete updated['3rd_place'];

  return updated;
}
